import {
    ADD_EXTRA,
    ADD_EXTRAS,
    DELETE_DC_SOURCES_ACCOUNT,
    RENAME_GA_PAYMENT,
    SET_EXTRA,
    UPDATE_EXTRA_BY_NAME,
    UPDATE_RECIEVE_ML_ACCOUNT,
    UPDATE_RECIEVE_ML_CARD,
} from 'apps/promo/actions/extraAction';
import update from 'apps/promo/helpers/Immutability';

const findIndexById = (accounts, id) => {
    return accounts.findIndex((account) => account.id === id);
};

const extra = (state = {}, action = {}) => {
    let mergeState = state;
    switch (action.type) {
        case SET_EXTRA:
            mergeState = update(state, { $set: action.extra });
            break;
        case ADD_EXTRAS:
            mergeState = update(state, { $auto: { $merge: action.extra } });
            break;
        case UPDATE_EXTRA_BY_NAME:
            mergeState = update(state, {
                $auto: {
                    [action.extraName]: { $set: action.value },
                },
            });
            break;
        case ADD_EXTRA:
            mergeState = update(state, {
                $auto: {
                    [action.extraName]: { $set: action.extra },
                },
            });
            break;
        case UPDATE_RECIEVE_ML_CARD:
            mergeState = update(state, {
                $auto: {
                    payment_info: {
                        card: {
                            cardAlias: { $set: action.alias },
                            code: { $set: action.code },
                            paymentSystem: { $set: action.paymentSystem },
                            cardLogo: { $set: action.cardLogo },
                            cvvFocus: { $set: action.cvvFocus },
                        },
                        code: { $set: action.code },
                    },
                },
            });
            break;
        case UPDATE_RECIEVE_ML_ACCOUNT:
            mergeState = update(state, {
                $auto: {
                    payment_info: {
                        account: {
                            code: { $set: action.code },
                            alias: { $set: action.alias },
                            bankLogo: { $set: action.bankLogo },
                        },
                        code: { $set: action.code },
                    },
                },
            });
            mergeState = update(state, {
                $auto: {
                    payment_info: {
                        account: {
                            code: { $set: action.code },
                            alias: { $set: action.alias },
                            bankLogo: { $set: action.bankLogo },
                        },
                        code: { $set: action.code },
                    },
                },
            });
            break;
        case DELETE_DC_SOURCES_ACCOUNT:
            const index = findIndexById(state.dcSources[action.typeAccount], action.accountId);
            mergeState = update(state, {
                $auto: {
                    dcSources: {
                        [action.typeAccount]: { $splice: [[index, 1]] },
                    },
                },
            });
            break;
        case RENAME_GA_PAYMENT:
            state.history.forEach((record, index) => {
                if (record.payId === action.payId && record.payTitle !== action.name) {
                    record.payTitle = action.name;
                    record.mobileInfo.title = action.name;
                    const newEntity = { ...record };
                    mergeState = update(state, {
                        history: {
                            [index]: { $set: newEntity },
                        },
                    });
                }
            });
            break;
    }
    return mergeState;
};
export default extra;
